const getCompanySlugFromHost = () => {
  const isDevelopment = window.location.origin.includes('localhost');
  const SUBDOMAIN_REGEX = /(?:http[s]*:\/\/)*(.*?)\.(?=[^/]*\..{2,5})/i;
  const hostname = isDevelopment ? localStorage.getItem('apiHost') : window?.location?.hostname;
  const subdomain = hostname.match(SUBDOMAIN_REGEX);

  // regex returns array
  const companySlug = subdomain?.[1] || '';

  return companySlug;
};

export default getCompanySlugFromHost;
